<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">Why is my payment on hold?</h1>

			<p>
				Payments can go on hold for a few reasons. Most likely the buyer had some sort of issue with the item and sent a message requesting information
				or a refund.
				Please <a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.item_id)}#lastmessage`">Click Here</a>
				to see
				your messages for this order
			</p>
		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../components/BaseNavLinks';

	export default {
		name: "WhyOnHold",

		components: {
			BaseNavLinks,
		},
	}
</script>

<style scoped>

</style>